import { findFrequencyValue, checkFrequencyLimitsFor, checkFrequencyProportionFor, checkFrequencyProportionsOnce, checkFrequencyLimits } from "../../../utils/frequency";
/**
 * Validates the frequency cap day time unit.
 * @param caps: The frequency caps array associated with the frequencies key.
 * @returns An error message, if there is an error. Else, undefined.
 */
export const checkDayCapFor = (caps) => {
    const dayCap = findFrequencyValue(caps, "DAY");
    if (dayCap === undefined) {
        return "Daily Frequency Cap must be defined.";
    }
    if (Number(dayCap) === 0) {
        return "Frequency cap must be set to a value greater than 0.";
    }
    return undefined;
};
/**
 * Similar to validateFrequency, but isolated to the passed-in time unit.
 * @param timeUnit: The time unit you want an error message for.
 * @param caps: The frequency caps array associated with the frequencies key.
 * @returns An error message, if there is an error. Else, undefined.
 */
export const validateFrequencyFor = (timeUnit, caps) => {
    if (!caps)
        return undefined;
    if (timeUnit === "DAY") {
        const dayCapError = checkDayCapFor(caps);
        if (dayCapError) {
            return dayCapError;
        }
    }
    const proportionErrors = checkFrequencyProportionFor(timeUnit, caps);
    if (proportionErrors) {
        return proportionErrors;
    }
    const limitErrors = checkFrequencyLimitsFor(timeUnit, caps);
    if (limitErrors) {
        return limitErrors;
    }
    return undefined;
};
/**
 * @param caps: the frequency caps array associated with the frequencies key.
 * @return: an error message, if there is an error. Else, undefined.
 */
export const validateFrequency = (caps) => {
    if (!caps || !caps.length)
        return undefined;
    const dayCapError = checkDayCapFor(caps);
    if (dayCapError) {
        return dayCapError;
    }
    const proportionErrors = checkFrequencyProportionsOnce(caps);
    if (proportionErrors) {
        return proportionErrors;
    }
    const limitErrors = Object.values(checkFrequencyLimits(caps) || {}).join(", ");
    if (limitErrors) {
        return limitErrors;
    }
    return undefined;
};
//# sourceMappingURL=frequency.js.map